import styled from 'styled-components'

export const CheckboxIconWrapper = styled.div`
  height: 20px;
  svg {
    height: 20px;
    width: 20px;
  }
`
